import React from "react";
import "../SellerOrderDetails/SellerOrderDetails.css";
import orcheck from '../../assets/or-check.png'
import ordercheck from '../../assets/order2.png'
import delivered from '../../assets/delivered.png'

export default function SellerOrderDetails() {
  return (
    <div className="container orderdetails-page">

      {/* عنوان الصفحة */}
      <h1 className="page-title pt-4 pb-3">
        تفاصيل الطلب / <span className="neworders">الطلبات الجديدة</span>
      </h1>

      <div className="buttonn mb-4">
        <button className="order-btn">الطلب</button>
      </div>

      <div className="customer-box">
        <div className="customer-info">

          <div className="right-side">
            <div className="icon-and-text">

              <div className="text-side">
                <h4 className="name text-dark">احمد محمد</h4>
                <p className="phone">+966 5145125</p>
                <p className="location">المملكة العربية السعودية، الرياض</p>
              </div>

              <div className="info">
                <i className="fa-solid fa-user"></i>
              </div>

            </div>
          </div>

          <div className="left-side-price">
            100 ر.س
          </div>

        </div>
      </div>

<div className="buttonn pt-1">
  <button className="product-btn">تفاصيل المنتج</button>
</div>
<div className="product-details-box ">

  <div className="row-line">
    <span className="label">اسم المنتج</span>
    <p className="value">سترة شتوية بسعر خاص</p>
  </div>

  <div className="row-line">
    <span className="label">الكمية</span>
    <p className="value">1</p>
  </div>

  <div className="row-line">
    <span className="label">السعر</span>
    <p className="value">100 ر.س</p>
  </div>

  <div className="row-line">
    <span className="label">مصاريف الشحن</span>
    <p className="value">200 ر.س</p>
  </div>

  <div className="row-line total">
    <span className="label">الإجمالي</span>
    <p className="value">1000 ر.س</p>
  </div>

</div>
  
 <div className="buttonn ">
  <button className="product-btn">حالة الطلب</button>
</div> 
<div className="order-status-section">

  {/* <div className="status-header">
    <button className="status-btn">حالة الطلب</button>
  </div> */}
<div className="order-timeline">

  <div className="timeline-gray"></div>
  <div className="timeline-orangee"></div>

  <div className="timeline-steps">

    <div className="t-step">
      <div className="t-circle delivered">
        <img src={delivered} alt="تم الاستلام" />
      </div>
      <p className="t-title">تم الاستلام</p>
      <p className="t-date">2025/12/10</p>
    </div>

    <div className="t-step">
      <div className="t-circle accepted">
        <img src={ordercheck} alt="تم الشحن" />
      </div>
      <p className="t-title ">تم الشحن</p>
      <p className="t-date">2025/12/10</p>
    </div>

    <div className="t-step">
      <div className="t-circle active">
        <img src={orcheck} alt="تم تأكيد الطلب" />
      </div>
      <p className="t-title">تم تأكيد الطلب</p>
      <p className="t-date">2025/12/10</p>
    </div>

  </div>
</div>



  <div className="confirm-wrapper ">
    <button className="confirm-btn mb-5 mt-3 pt-3 pb-3">تأكيد الطلب</button>
  </div>

</div>




    </div>
  );
}
